import {
    formatDuration,
    formatDurationTooltip,
    formatNumber,
} from "@/dashboards/widgets/fantasticchart/FantasticUtilities";
import VuexStore from "@/store/vuex/VuexStore";
import {
    appendFiltersReadably,
} from "@/dashboards/filter/FilterParser";
import {countTickets} from "@/data/Grouse";
import {currentAccountCode} from "@/app/utils/Account";
import * as b3js from "brandseyejs";
import {getMetatagsInAccount} from "@/app/utils/Metatags";

export default {
    "ticketIdCount": {
        name: "Engage Tickets",
        chartName: "Engage Tickets",
        tooltipTemplate: require("@/dashboards/widgets/fantasticchart/FantasticCountTip.handlebars"),
        yLabel: {long: "Engage Tickets", short: "# active tickets"},
        formatY: formatNumber,
        formatLabel: formatNumber,
        extendData: function (d) {
            return {ticketCount: d}
        },
        getter: function(d) {
            return d["ticketCount"] ?? 0;
        },
        defaultSortOptions: {
            label: "Engage tickets",
            field: "ticketIdCount",
            order: "descending"
        },
        extraFilterWhenY: function () {
            return "ticketId isnt unknown";
        },
        async getData(model, query, groupBy, ignore, ignoreY, getData) {
            await VuexStore.dispatch('refreshTags');
            let tags = VuexStore.state.tags;
            const xAxis = model.get("xAxis");
            const { filter, includedTags } = applyTagFilterForAxis(query.filter, xAxis);
            const groupByField = getGroupByField(groupBy.at(0), xAxis);
            if (model.attributes.dataSets) {
                let data = await Promise.all(model.attributes.dataSets.map (dataset => {
                    return countTickets(
                        appendFiltersReadably(filter, dataset.filter),
                        groupByField,
                        ["ticketId"],
                        null,
                        { allTagsRequired: true },
                        currentAccountCode()
                    )
                        .then(ans => {
                            if (Array.isArray(ans)) {
                                return ans.map(item => (
                                    {
                                        ... item,
                                        "dataSet.id": dataset.id,
                                        "dataSet.label": dataset.label,
                                        _dataSet: dataset
                                    }));
                            } else {
                                return {... ans, dataset: dataset};
                            }
                        })
                }));
                return data.map(it => mapCountTicketsResults(it, groupByField, tags, includedTags, xAxis)).flat();
            }
            const data = await countTickets(filter, groupByField,["ticketId"], null, {}, currentAccountCode());
            return mapCountTicketsResults(data, groupByField, tags, includedTags, xAxis);
        }
    },
    "aveTicketResolutionTime": {
        name: "Average Ticket Resolution time",
        chartName: "Average Ticket Resolution Times",
        yLabel: {long: "Average Ticket Resolution Times", short: "# average resolution time"},
        isDuration: true,
        formatY: formatDuration,
        formatLabel: formatDuration,
        tooltipArticle: "an",
        formatTooltipY: formatDurationTooltip,
        extendData: function (d) {
            return {aveResolutionTime: d};
        },
        getter: function(d) {
            return d["aveResolutionTime"] ?? 0;
        },
        defaultSortOptions: {
            label: "Average Ticket Resolution Times",
            field: "aveResolutionTime",
            order: "descending"
        },
        extraFilterWhenY: function () {
            return "ticketId isnt unknown";
        },
        async getData(model, query, groupBy, ignore, ignoreY, getData) {

            const xAxis = model.get("xAxis");
            await VuexStore.dispatch('refreshTags');
            let tags = VuexStore.state.tags;
            const { filter, includedTags } = applyTagFilterForAxis(query.filter, xAxis);
            const groupByField = getGroupByField(groupBy.at(0), xAxis);
            const data = await countTickets(filter, groupByField, ["resolutionTime"], null, {}, currentAccountCode());
            return mapCountTicketsResults(data, groupByField, tags, includedTags, xAxis);
        }
    },
    "aveTicketTransactionTime": {
        name: "Average Ticket Transaction time",
        chartName: "Average Ticket Transaction Times",
        yLabel: {long: "Average Ticket Transaction Times", short: "# average ransaction time"},
        isDuration: true,
        formatY: formatDuration,
        formatLabel: formatDuration,
        tooltipArticle: "an",
        formatTooltipY: formatDurationTooltip,
        extendData: function (d) {
            return {aveResolutionTime: d};
        },
        getter: function(d) {
            return d["aveTransactionTime"] ?? 0;
        },
        defaultSortOptions: {
            label: "Average Ticket Transaction Times",
            field: "aveTransactionTime",
            order: "descending"
        },
        extraFilterWhenY: function () {
            return "ticketId isnt unknown";
        },
        async getData(model, query, groupBy, ignore, ignoreY, getData) {

            const xAxis = model.get("xAxis");
            await VuexStore.dispatch('refreshTags');
            let tags = VuexStore.state.tags;
            const { filter, includedTags } = applyTagFilterForAxis(query.filter, xAxis);
            const groupByField = getGroupByField(groupBy.at(0), xAxis);
            const data = await countTickets(filter, groupByField, ["transactionTime"], null, {}, currentAccountCode());
            return mapCountTicketsResults(data, groupByField, tags, includedTags, xAxis);
        }
    },
    "aveTicketResolutionTimeWh": {
        name: "Average Ticket Resolution time (working hours)",
        chartName: "Average Ticket Resolution Time (working hours)",
        yLabel: {long: "Average Ticket Resolution Time (working hours)", short: "# average resolution time (working hours)"},
        isDuration: true,
        formatY: formatDuration,
        formatLabel: formatDuration,
        tooltipArticle: "an",
        formatTooltipY: formatDurationTooltip,
        extendData: function (d) {
            return {aveResolutionTimeWh: d}
        },
        getter: function(d) {
            return d["aveResolutionTimeWh"] ?? 0;
        },
        defaultSortOptions: {
            label: "Average Ticket Resolution Times",
            field: "aveResolutionTimeWh",
            order: "descending"
        },
        extraFilterWhenY: function () {
            return "ticketId isnt unknown";
        },
        async getData(model, query, groupBy, ignore, ignoreY, getData) {

            const xAxis = model.get("xAxis");
            await VuexStore.dispatch('refreshTags');
            let tags = VuexStore.state.tags;
            const { filter, includedTags } = applyTagFilterForAxis(query.filter, xAxis);
            const groupByField = getGroupByField(groupBy.at(0), xAxis);
            const data = await countTickets(filter, groupByField, ["resolutionTimeWh"], null, {}, currentAccountCode());
            return mapCountTicketsResults(data, groupByField, tags, includedTags, xAxis);
        }
    },
    "aveTicketTransactionTimeWh": {
        name: "Average Ticket Transaction time (working hours)",
        chartName: "Average Ticket Transaction Time (working hours)",
        yLabel: {long: "Average Ticket Transaction Time (working hours)", short: "# average transaction time (working hours)"},
        isDuration: true,
        formatY: formatDuration,
        formatLabel: formatDuration,
        tooltipArticle: "an",
        formatTooltipY: formatDurationTooltip,
        extendData: function (d) {
            return {aveResolutionTimeWh: d}
        },
        getter: function(d) {
            return d["aveTransactionTimeWh"] ?? 0;
        },
        defaultSortOptions: {
            label: "Average Ticket Transaction Times",
            field: "aveTransactionTimeWh",
            order: "descending"
        },
        extraFilterWhenY: function () {
            return "ticketId isnt unknown";
        },
        async getData(model, query, groupBy, ignore, ignoreY, getData) {

            const xAxis = model.get("xAxis");
            await VuexStore.dispatch('refreshTags');
            let tags = VuexStore.state.tags;
            const { filter, includedTags } = applyTagFilterForAxis(query.filter, xAxis);
            const groupByField = getGroupByField(groupBy.at(0), xAxis);
            const data = await countTickets(filter, groupByField, ["transactionTimeWh"], null, {}, currentAccountCode());
            return mapCountTicketsResults(data, groupByField, tags, includedTags, xAxis);
        }
    },
    "milestone": {
        tooltipPrepositionPercent: 'with milestone',
        tooltipComparePreposition: 'with milestone',
        tooltipMentionsWithVerb: 'with milestone',
        description: "A milestone is a tag applied to a ticket",
        name: "Milestone",
        tooltipArticle: "a",
        isMultiple: true,
        hideUnknown: true,
        noLimit: true,
        getter: function (d) {
            return d["milestone.name"]
        },
        setter: function (d, id, value) {
            d['milestone.id'] = id;
            d['milestone.name'] = value;
        },
        rawDataGetter(d) {return d._milestone;},
        rawDataSetter(d, data) {return d._milestone = data;},
        filterGetter() { return null },
        extendData(d) {
            return {
                "milestone.id": d.tagId,
                "milestone.name": d.tagName,
                "milestone.description": d.description,
                "_milestone": d
            };
        },
        scaleX: b3js.scaleDiscrete,
        async getData(model, query, groupBy, ignore, ignoreY, getData) {
            if (model.get("yAxis") !== 'ticketIdCount') throw Error("Can not count milestones for x axis field: " + model.get("yAxis"));
        }
    },
    "milestoneStatus": {
        tooltipPrepositionPercent: 'with milestone',
        tooltipComparePreposition: 'with milestone',
        tooltipMentionsWithVerb: 'with milestone',
        description: "A milestone is a tag applied to a ticket",
        name: "Milestone Status",
        tooltipArticle: "a",
        isMultiple: true,
        hideUnknown: true,
        groupBy: ["milestone"],
        noLimit: true,
        getter: function (d) {
            return d["milestone.name"]
        },
        setter: function (d, id, value) {
            d['milestone.id'] = id;
            d['milestone.name'] = value;
        },
        rawDataGetter(d) {return d._milestone;},
        rawDataSetter(d, data) {return d._milestone = data;},
        filterGetter() { return null },
        extendData(d) {
            return {
                "milestone.id": d.tagId,
                "milestone.name": d.tagName,
                "milestone.description": d.description,
                "_milestone": d
            };
        },
        scaleX: b3js.scaleDiscrete,
        async getData(model, query, groupBy, ignore, ignoreY, getData) {
            if (model.get("yAxis") !== 'ticketIdCount') throw Error("Can not count milestones for x axis field: " + model.get("yAxis"))
        }
    },
    "Priority": {
        tooltipPrepositionPercent: 'with milestone',
        tooltipComparePreposition: 'with milestone',
        tooltipMentionsWithVerb: 'with milestone',
        description: "A milestone is a tag applied to a ticket",
        name: "Milestone Status",
        tooltipArticle: "a",
        isMultiple: true,
        hideUnknown: true,
        groupBy: ["milestone"],
        noLimit: true,
        getter: function (d) {
            return d["milestone.name"]
        },
        setter: function (d, id, value) {
            d['milestone.id'] = id;
            d['milestone.name'] = value;
        },
        rawDataGetter(d) {return d._milestone;},
        rawDataSetter(d, data) {return d._milestone = data;},
        filterGetter() { return null },
        extendData(d) {
            return {
                "milestone.id": d.tagId,
                "milestone.name": d.tagName,
                "milestone.description": d.description,
                "_milestone": d
            };
        },
        scaleX: b3js.scaleDiscrete,
        async getData(model, query, groupBy, ignore, ignoreY, getData) {
            if (model.get("yAxis") !== 'ticketIdCount') throw Error("Can not count milestones for x axis field: " + model.get("yAxis"));
        }
    },
}

function applyTagFilterForAxis(filter, xAxis) {
    let newFilter = filter;
    let tags = VuexStore.state.tags;
    let includedTags = [];

    if (xAxis === "engageusertag") {
        const engageUserTags = tags.filter(it => it.namespace === "engageusertags");
        includedTags = [...engageUserTags];
        const engageUserTagsFilter = `Tag IS ${engageUserTags.map(t => t.id).join(" OR TAG IS ")}`;
        newFilter = appendFiltersReadably(filter, engageUserTagsFilter);
    } else if (xAxis === "engageagenttag") {
        const engageAgentTags = tags.filter(it => it.namespace === "engageagenttag");
        includedTags = [...engageAgentTags];
        const engageAgentTagsFilter = `Tag IS ${engageAgentTags.map(t => t.id).join(" OR TAG IS ")}`;
        newFilter = appendFiltersReadably(filter, engageAgentTagsFilter);
    } else if (xAxis === "surveytemplatetag") {
        const surveyTemplateTags = tags.filter(it => it.namespace === "survey-template");
        includedTags = [...surveyTemplateTags];
        const surveyTemplateFilter = `Tag IS ${surveyTemplateTags.map(t => t.id).join(" OR TAG IS ")}`;
        newFilter = appendFiltersReadably(filter, surveyTemplateFilter);
    } else if (xAxis === "surveyQuestion") {
        const surveyQuestionTags = tags.filter(it => it.namespace === "survey-question");
        includedTags = [...surveyQuestionTags];
        const surveyQuestionFilter = `Tag IS ${surveyQuestionTags.map(t => t.id).join(" OR TAG IS ")}`;
        newFilter = appendFiltersReadably(filter, surveyQuestionFilter);
    }

    return {
        filter: newFilter,
        includedTags: includedTags
    };
}

function getGroupByField(groupByField, xAxis) {
    let groupBy = groupByField;
    if (groupByField === "milestoneStatus") groupBy = "milestone";
    if (xAxis === "rpcs" || xAxis === "priority") groupBy = "rpcs";
    return groupBy;
}

function mapCountTicketsResults(data, groupByField, tags, includedTags, xAxis) {
    if (groupByField === "tag") {
        let tagMap = tags.reduce((acc, obj) => {
            acc[obj.id] = obj;
            return acc;
        }, {});

        return data.map(
            it => ({
                ...it,
                tag: tagMap[it.tagId],
            })
        ).filter(it => it.tag).filter(it => includedTags.length === 0 || includedTags.includes(it.tag));
    }
    if (xAxis === "milestoneStatus") {
        return groupByStatus(data);
    }
    if (xAxis === "rpcs") {
        const metaTags = getMetatagsInAccount()
        return data
            .map(it => {
                const { priority, ...rest } = it;
                return {
                    ...rest,
                    [xAxis]: metaTags.find(tag => tag.code === priority)
                };
            })
            .filter(it => it[xAxis]);

    }
    if (xAxis === "priority") {
        // todo: this has to be generic in some way, such that this function does not have to know about the specific fields returned from grouse
        const low = data.find(it => it.priority === "LOW") || { ticketCount: 0 };
        const highCount = data
            .filter(it => it.priority !== "LOW")
            .reduce((sum, it) => sum + it.ticketCount, 0);
        const highAveTicketResolutionTime = data
            .filter(it => it.priority !== "LOW")
            .reduce((sum, it) => sum + it.aveResolutionTime, 0);
        const highAveTicketTransactionTime = data
            .filter(it => it.priority !== "LOW")
            .reduce((sum, it) => sum + it.aveTransactionTime, 0);
        const highAveTicketResolutionTimeWh = data
            .filter(it => it.priority !== "LOW")
            .reduce((sum, it) => sum + it.aveResolutionTimeWh, 0);
        const highAveTicketTransactionTimeWh = data
            .filter(it => it.priority !== "LOW")
            .reduce((sum, it) => sum + it.aveTransactionTimeWh, 0);

        return [
            {
                ticketCount: highCount,
                aveResolutionTimeWh: highAveTicketResolutionTimeWh,
                aveTransactionTimeWh: highAveTicketTransactionTimeWh,
                aveResolutionTime: highAveTicketResolutionTime,
                aveTransactionTime: highAveTicketTransactionTime,
                priority: { id: "high" }
            },
            {
                ticketCount: low.ticketCount,
                aveResolutionTimeWh: low.aveResolutionTimeWh,
                aveTransactionTimeWh: low.aveTransactionTimeWh,
                aveResolutionTime: low.aveResolutionTime,
                aveTransactionTime: low.aveTransactionTime,
                priority: { id: "low" }
            }
        ];
    }
    return data;
}

export async function getTicketsGroupedByStatus(filter) {
    const data = await countTickets(filter, "milestone", ["ticketId"], null, {}, currentAccountCode());
    return groupByStatus(data);
}

export async function getTicketPriorityFor(filter, category) {
    if (!["risk","purchase","cancel","service"].includes(category)) throw Error("Invalid rpcs category: " + category);
    const data = await countTickets(filter, "rpcs", ["ticketId"], null, {}, currentAccountCode());
    return data.find(it => it.priority.toLowerCase() === category);
}

export async function getTicketCountForStatusPending(filter) {
    return (await getTicketsGroupedByStatus(filter)).find(it => it.milestone.ticketStatus === "P").ticketCount ?? 0;
}

export async function getTicketCountForStatusClosed(filter) {
    return (await getTicketsGroupedByStatus(filter)).find(it => it.milestone.ticketStatus === "C").ticketCount ?? 0;
}

export async function getTicketCountForPriorityRisk(filter) {
    return (await getTicketPriorityFor(filter, "risk"))?.ticketCount ?? 0;
}

export async function getTicketCountForPriorityPurchase(filter) {
    return (await getTicketPriorityFor(filter, "purchase"))?.ticketCount ?? 0;
}

export async function getTicketCountForPriorityCancel(filter) {
    return (await getTicketPriorityFor(filter, "cancel"))?.ticketCount ?? 0;
}

export async function getTicketCountForPriorityService(filter) {
    return (await getTicketPriorityFor(filter, "service"))?.ticketCount ?? 0;
}

export function groupByStatus(arr) {
    const statusMap = { C: "Closed", P: "Pending" };

    // todo i have to make this generic such that select fields are not explicitly added/ mapped
    const grouped = arr.reduce((acc, item) => {
        const status = item.milestone.ticketStatus;
        if (!acc[status]) {
            acc[status] = {
                ticketCount: 0,
                aveResolutionTimeWh: 0,
                aveTransactionTimeWh: 0,
                milestone: {
                    tagId: [],
                    tagName: statusMap[status] || status,
                    ticketStatus: status,
                }
            };
        }

        acc[status].ticketCount += item.ticketCount;
        acc[status].aveResolutionTimeWh += item.aveResolutionTimeWh;
        acc[status].aveTransactionTimeWh += item.aveTransactionTimeWh;
        acc[status].milestone.tagId.push(item.milestone.tagId);

        return acc;
    }, {});

    // convert tagId arrays into comma-separated string (or keep array if you prefer)
    return Object.values(grouped).map(group => ({
        ...group,
        milestone: {
            ...group.milestone,
            tagId: group.milestone.tagId.join(",")
        }
    }));
}